import { Box, Grid, Switch } from "@material-ui/core";
import React, { useState } from "react";
import SwipeableViews from "react-swipeable-views";

import CustomTabs from "../../../../../common/Tabs";
import AccountCargoDetails from "../../../../../components/Calculator/AccountCargoDetails";
import ActionButtons from "../../../../../components/Calculator/ActionButtons";
import VesselContractForm from "../../../../../components/Calculator/AddCalculatorFleet/createVesselContractModel";
import BunkerSupplyMarginAllowance from "../../../../../components/Calculator/BunkerSupplyMarginAllowancesTable";
import CalculatorVesselDetails from "../../../../../components/Calculator/CalculatorVesselDetails";
import DailyExpensesModal from "../../../../../components/Calculator/DailyExpensesModal";
import Expenses from "../../../../../components/Calculator/Expenses";
import MarginAndAllowances from "../../../../../components/Calculator/MarginAndAllowances";
import MarginAllowancesTable from "../../../../../components/Calculator/MarginAllowancesTable";
import PortOperations from "../../../../../components/Calculator/PortOperations";
import Result from "../../../../../components/Calculator/Result";
import SplitHireModal from "../../../../../components/Calculator/SplitHireModal";
import CustomAddModal from "../../../../../components/Common/CustomAddModal";
import { LabelActionGuide } from "../../../../../components/Common/ShareWithOrg";
import CustomShowModal from "../../../../../components/Common/CustomShowModal";
import CreateCargoContractForm from "../../../Orders/createCargoContractModel";

import { useSavedContractsController } from "../hooks/useSavedContractsController";

export function SavedContractsView(props) {
  const {
    setLoader = () => { },
    tabs: propsTabs = [],
    active = 0,
    handleMainTabChange = () => { },
  } = props;

  const controller = useSavedContractsController(props);
  const [marginModal, setMarginModal] = useState(false);

  const {
    id,
    isViewOnly,
    calculatorData,
    setCalculatorData,
    selectedVessels,
    setSelectedVessels,
    syncBunker,
    setSyncBunker,
    isOverride,
    setIsOverride,
    cargoFormData,
    setCargoFormData,
    vesselFormData,
    setVesselFormData,
    prevAttachments,
    setPrevAttachments,
    cargoTextContract,
    setCargoTextContract,
    vesselTextContract,
    setVesselTextContract,
    cargoAttachments,
    vesselAttachments,
    inputValue,
    setInputValue,
    estimationCopyModelOpen,
    setEstimationCopyModelOpen,
    editCargoContractModelOpen,
    setEditCargoContractModelOpen,
    editVesselContractModelOpen,
    setEditVesselContractModelOpen,
    supplyModal,
    setSupplyModal,
    splitHireModal,
    setSplitHireModal,
    showExpensesModal,
    setShowExpensesModal,
    openAddOperation,
    setOpenAddOperation,
    setOpenAddOperationindex,
    IsEditable,
    activeTab,
    fleetCheckbox,
    setFleetCheckbox,
    swipeableActions,

    // Handlers
    getInitialData,
    handleTabChange,
    handleSwipeChange,
    onChangeClientQuery,
    onChangeSelectedVessel,
    onChangePortOperations,
    onChangeBunkerScrubber,
    onChangeSyncBunker,
    onChangeSplitHire,
    addRow,
    onDeleteOperations,
    onAddOperations,
    onClickCalculate,
    onClickCalculateAndSave,
    sendCalculationRequest,
    onFetchPortOperationDistance,
    onSetOpenMap,
    onClickCopyToEstimate,
    handleCopyToEstimation,
    onClickEditCargoContract,
    onClickVesselCargoContract,
    handleUpdateCargoContract,
    handleUpdateVesselContract,
    removeCargoAttachment,
    handleCargoContractInputChange,
    handleCargoTextContractUpload,
    handleCargoContractAttachmentUpload,
    removeVesselAttachment,
    handleVesselContractInputChange,
    handleVesselTextContractUpload,
    handleVesselContractAttachmentUpload,
    calculationErrors,
  } = controller;

  const tabs = ["Port Operations", "Bunker & Margin Allowance"];

  return (
    <>
      <Grid className="calculator-section min-h-[calc(100vh-60px)] px-0 md:px-2.5 pt-1 pb-2">
        <Grid item xs={12}>
          <div className="quick-menu-bar items-center grid grid-cols-1 md:grid-cols-6 justify-between pb-1 m-0">
            {id && (
              <div className="md:col-span-2 w-fit">
                <CustomTabs
                  tabs={propsTabs}
                  active={active}
                  onChange={handleMainTabChange}
                />
              </div>
            )}
            <div className="md:col-span-4">
              {!isViewOnly ? (
                <ActionButtons
                  IsQuerySelected
                  onSetOpenMap={onSetOpenMap}
                  onClickCalculate={onClickCalculate}
                  onClickCalculateAndSave={onClickCalculateAndSave}
                  isPublic={!IsEditable}
                  isContractPage
                  onClickCopyToEstimate={onClickCopyToEstimate}
                />
              ) : (
                <div className="py-5"></div>
              )}
            </div>
          </div>
          <Grid container spacing={1}>
            {/* Cargo Details */}
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
                <AccountCargoDetails
                  isFromSingleVesselCalcy
                  calculatorData={calculatorData}
                  setLoader={setLoader}
                  getInitialData={getInitialData}
                  isContractEstimate
                  IsEditable={IsEditable}
                  onClickEditCargoContract={onClickEditCargoContract}
                />
              </div>
            </Grid>

            {/* Vessel Details */}
            <Grid item xs={12} sm={6} md={8} lg={4}>
              <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
                <CalculatorVesselDetails
                  setLoader={setLoader}
                  setSelectedVessels={setSelectedVessels}
                  selectedVessels={selectedVessels}
                  calculatorData={calculatorData}
                  setCalculatorData={setCalculatorData}
                  onChangeHandler={onChangeSelectedVessel}
                  fleetCheckbox={fleetCheckbox}
                  setFleetCheckbox={setFleetCheckbox}
                  isContractEstimate
                  onClickEditVesselContract={onClickVesselCargoContract}
                />
              </div>
            </Grid>

            {/* Margin & Allowances */}
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
                <MarginAndAllowances
                  isFromSingleVesselCalcy
                  onChangeSelectedVessel={onChangeSelectedVessel}
                  selectedVessels={selectedVessels}
                  setSelectedVessels={setSelectedVessels}
                  setMarginModal={setMarginModal}
                  calculatorData={calculatorData}
                  setCalculatorData={setCalculatorData}
                  syncBunker={syncBunker}
                  setSyncBunker={setSyncBunker}
                  setSupplyModal={() => setSupplyModal(true)}
                  onChangeSyncBunker={onChangeSyncBunker}
                  isOverride={isOverride}
                  setIsOverride={setIsOverride}
                  isContractEstimate
                />
              </div>
            </Grid>

            {/* Expenses */}
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
                <Expenses
                  isFromSingleVesselCalcy
                  onChangeSelectedVessel={onChangeSelectedVessel}
                  selectedVessels={selectedVessels}
                  calculatorData={calculatorData}
                  setCalculatorData={setCalculatorData}
                  setShowExpensesModal={setShowExpensesModal}
                  openSplitHireModal={() => setSplitHireModal(true)}
                />
              </div>
            </Grid>

            {/* Result */}
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <div className="upper-section-grid bg-white border border-[#cbd5e1] min-h-full">
                <Result
                  selectedVessels={selectedVessels}
                  calculationErrors={calculationErrors}
                />
              </div>
            </Grid>

            {/* Middle Section - Full width */}
            <div className="w-full mt-2 mb-1">
              <div className="flex flex-wrap justify-between items-end gap-y-1 relative z-10 w-full">
                <div className="flex space-x-1 items-end">
                  {tabs.map((tab, index) => {
                    const isActive = activeTab === index;
                    return (
                      <button
                        key={index}
                        onClick={() => handleTabChange(index)}
                        className={`
                          group relative px-3 sm:px-5 py-1 text-xs font-semibold whitespace-nowrap rounded-t-lg transition-all duration-200 ease-out focus:outline-none
                          ${isActive
                            ? "bg-[#313C4C] text-white translate-y-[1px]"
                            : "bg-slate-200/50 text-slate-500 hover:bg-slate-200 hover:text-slate-700 border-x border-t border-transparent pb-1.5"
                          }
                        `}
                      >
                        {tab}
                      </button>
                    );
                  })}
                </div>

                {activeTab === 1 && (
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mb-1 mr-0 sm:mr-4 px-2 sm:px-0 w-full sm:w-auto text-[11px]">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ marginRight: "6px", fontSize: "11px", fontWeight: 500, color: "#000000" }}>
                        TC Adcom %:
                      </span>
                      <input
                        type="number"
                        name="tcAdcom"
                        className="focus:outline focus:outline-[1.5px] focus:outline-[#d97706] focus:-outline-offset-[1.5px] focus:bg-white"
                        style={{
                          width: "60px",
                          border: "1px solid #a3b8cb",
                          height: "19px",
                          padding: "0 4px",
                          fontSize: "11px",
                          fontWeight: 500,
                          color: "#000000",
                          borderRadius: "2px",
                          outline: "none",
                        }}
                        value={calculatorData?.clientQuery?.tcAdcom || ""}
                        onChange={onChangeClientQuery}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label
                        style={{
                          fontSize: "11px",
                          fontWeight: 500,
                          color: "#000000",
                          marginRight: "4px",
                          margin: 0,
                          cursor: "pointer",
                        }}
                      >
                        Allow Fuel Price Adjustments
                      </label>
                      <Switch
                        size="small"
                        checked={syncBunker}
                        onChange={(e) => onChangeSyncBunker(e.target.checked)}
                        name="checkedA"
                        color="primary"
                        style={{ margin: 0 }}
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Elevated Content Container */}
              <div className=" shadow-[0_8px_30px_rgb(0,0,0,0.04)] relative z-0 overflow-hidden">
                <SwipeableViews
                  index={activeTab}
                  onChangeIndex={handleSwipeChange}
                  className="w-full"
                  animateHeight
                  action={(actions) => {
                    swipeableActions.current = actions;
                  }}
                >
                  <div className="p-0">
                    <div className="middle-section-grid">
                      <PortOperations
                        sendCalculationRequest={sendCalculationRequest}
                        onChangePortOperations={onChangePortOperations}
                        calculatorData={calculatorData}
                        setCalculatorData={setCalculatorData}
                        onAddOperations={onAddOperations}
                        onDeleteOperations={onDeleteOperations}
                        onChangeSyncBunker={onChangeSyncBunker}
                        onFetchPortOperationDistance={onFetchPortOperationDistance}
                        openAddOperation={openAddOperation}
                        setOpenAddOperation={setOpenAddOperation}
                        setOpenAddOperationindex={setOpenAddOperationindex}
                        supplyModal={supplyModal}
                        setSupplyModal={setSupplyModal}
                        isOverride={isOverride}
                        setIsOverride={setIsOverride}
                        selectedVessels={selectedVessels}
                        onChangeSelectedVessel={onChangeSelectedVessel}
                        isContractEstimate
                        disableEdit={!IsEditable}
                        onClickCalculateAndSave={onClickCalculateAndSave}
                      />
                    </div>
                  </div>
                  <div className="p-0">
                    <div>
                      <BunkerSupplyMarginAllowance
                        portOperation={calculatorData.portOperation}
                        syncBunker={syncBunker}
                        setSyncBunker={setSyncBunker}
                        clientQuery={selectedVessels?.clientQuery}
                        onChangeBunkerScrubber={onChangeBunkerScrubber}
                        selectedVessels={selectedVessels}
                        onChangeSyncBunker={onChangeSyncBunker}
                        onChangeSelectedVessel={onChangeSelectedVessel}
                        onChangePortOperations={onChangePortOperations}
                        isOverride={isOverride}
                        setIsOverride={setIsOverride}
                        calculatorData={calculatorData}
                        setCalculatorData={setCalculatorData}
                      />
                    </div>
                  </div>
                </SwipeableViews>
              </div>
            </div>

            {/* Remarks */}
            <Grid item xs={12} md={6}>
              <div className="lower-section-grid">
                <div className="selected-vessel-remark">
                  <p>
                    Remarks:
                    <span>
                      {(selectedVessels && selectedVessels.remark) || ""}
                    </span>
                  </p>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>

        <CustomAddModal
          open={estimationCopyModelOpen}
          title={"Copy To Estimation"}
          maxWidth="sm"
          saveLabel="Copy"
          handleClose={() => setEstimationCopyModelOpen(false)}
          onSubmitConfirm={handleCopyToEstimation}
        >
          <Box>
            <LabelActionGuide title="Copy this pre-fix estimate">
              Create a separate copy of this pre-fix estimate. Find it in Contracts → My Contracts → Pre-Fix Estimate.
            </LabelActionGuide>
            <label className="block text-xs font-medium text-slate-700">
              <span className="mb-1 block">Estimate name</span>
              <input
                placeholder="Enter Estimate Name"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleCopyToEstimation();
                  }
                }}
                className="p-2 border w-full border-gray-300 rounded-md"
              />
            </label>
          </Box>
        </CustomAddModal>

        <CustomShowModal
          open={splitHireModal}
          handleClose={() => setSplitHireModal(false)}
          maxWidth="xs"
          title="Split Hire"
        >
          <SplitHireModal
            addNewSplitHire={addRow}
            selectedSplitHire={calculatorData.fleetList?.[0]}
            onChangeSplitHire={onChangeSplitHire}
          />
        </CustomShowModal>

        {IsEditable ? (
          <CustomAddModal
            open={editCargoContractModelOpen}
            title={"Update Cargo Contract"}
            maxWidth="md"
            saveLabel={"Update"}
            handleClose={() => setEditCargoContractModelOpen(false)}
            onSubmitConfirm={handleUpdateCargoContract}
          >
            <CreateCargoContractForm
              formData={cargoFormData}
              setFormData={setCargoFormData}
              handleChange={handleCargoContractInputChange}
              removeAttachment={removeCargoAttachment}
              textContract={cargoTextContract}
              handleTextContractUpload={handleCargoTextContractUpload}
              handleAttachmentUpload={handleCargoContractAttachmentUpload}
              attachments={cargoAttachments}
              setTextContract={setCargoTextContract}
              isEditing
              prevAttachments={prevAttachments}
              setPrevAttachments={setPrevAttachments}
            />
          </CustomAddModal>
        ) : (
          <CustomShowModal
            open={editCargoContractModelOpen}
            title={"View Cargo Contract"}
            maxWidth="md"
            handleClose={() => setEditCargoContractModelOpen(false)}
          >
            <CreateCargoContractForm
              formData={cargoFormData}
              setFormData={setCargoFormData}
              handleChange={handleCargoContractInputChange}
              removeAttachment={removeCargoAttachment}
              textContract={cargoTextContract}
              handleTextContractUpload={handleCargoTextContractUpload}
              handleAttachmentUpload={handleCargoContractAttachmentUpload}
              attachments={cargoAttachments}
              setTextContract={setCargoTextContract}
              isEditing
              prevAttachments={prevAttachments}
              setPrevAttachments={setPrevAttachments}
            />
          </CustomShowModal>
        )}

        {IsEditable ? (
          <CustomAddModal
            open={editVesselContractModelOpen}
            title={"Update Vessel Contract"}
            maxWidth="md"
            saveLabel={"Update"}
            handleClose={() => setEditVesselContractModelOpen(false)}
            onSubmitConfirm={handleUpdateVesselContract}
          >
            <VesselContractForm
              formData={vesselFormData}
              setFormData={setVesselFormData}
              handleChange={handleVesselContractInputChange}
              attachments={vesselAttachments}
              textContract={vesselTextContract}
              removeAttachment={removeVesselAttachment}
              handleTextContractUpload={handleVesselTextContractUpload}
              handleAttachmentUpload={handleVesselContractAttachmentUpload}
              isEditing
              setTextContract={setVesselTextContract}
              prevAttachments={prevAttachments}
              setPrevAttachments={setPrevAttachments}
            />
          </CustomAddModal>
        ) : (
          <CustomShowModal
            open={editVesselContractModelOpen}
            handleClose={() => setEditVesselContractModelOpen(false)}
            title="View Vessel Contract"
            maxWidth="md"
          >
            <VesselContractForm
              formData={vesselFormData}
              setFormData={setVesselFormData}
              handleChange={handleVesselContractInputChange}
              attachments={vesselAttachments}
              textContract={vesselTextContract}
              removeAttachment={removeVesselAttachment}
              handleTextContractUpload={handleVesselTextContractUpload}
              handleAttachmentUpload={handleVesselContractAttachmentUpload}
              isEditing
              setTextContract={setVesselTextContract}
              prevAttachments={prevAttachments}
              setPrevAttachments={setPrevAttachments}
            />
          </CustomShowModal>
        )}

        <CustomShowModal
          open={showExpensesModal}
          handleClose={() => setShowExpensesModal(false)}
          title="Expenses Per Day"
        >
          <DailyExpensesModal
            calculatorData={calculatorData}
            setCalculatorData={setCalculatorData}
            dailyExpenses={calculatorData?.clientQuery?.dailyExpenses}
            open={showExpensesModal}
          />
        </CustomShowModal>

        <CustomShowModal
          open={marginModal}
          handleClose={() => setMarginModal(false)}
          maxWidth="sm"
          title="Margin Allowances Table"
        >
          <MarginAllowancesTable
            calculatorData={calculatorData}
            setCalculatorData={setCalculatorData}
          />
        </CustomShowModal>
      </Grid>
    </>
  );
}
